import { Table } from "../../features/Table";
import { type StockExchange, stock_exchanges_columns } from "./columns";
import { FilterStockExchange } from "./filter";
import { useLocation } from "react-router-dom";

const client = "instit-quantilia";
const table_name = "stock_exchanges";

export const StockExchangesTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<StockExchange, StockExchange>
      label="Stock Exchanges"
      client={client}
      table_name={table_name}
      columns={stock_exchanges_columns}
      disable_translations_request={true}
      filter={<FilterStockExchange />}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
